export default class MotivoService {
  constructor(resource) {
    this._resource = resource;
  }

  getMotivo() {
    return this._resource.get(`atendimento/motivo`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error(err.body);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/atendimento/MotivoService.js